import React from 'react';
import { connect } from 'react-redux';
import * as UserActions from '../../actions/userActions';


import { Link } from 'react-router-dom';

export const Banner = ({ children }) =>
    <div className="banner">{ children }</div>;

class EmailVerificationBannerWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      success: false,
      error: false,
      showAlert: false,
    };

  }


  render () {
    const { user } = this.props;
    
    const isEmailVerified = user && user.hasOwnProperty('isEmailVerified') ?
      user.isEmailVerified: false;
      const isPhoneVerified = user && user.hasOwnProperty('isPhoneVerified') ?
      user.isPhoneVerified: false;

    if (!user) {
      return null;
    }
    if (isEmailVerified && isPhoneVerified) {
      return null;
    }

    if(user.isVerified){
      return null;
    }
   let text="";
   let placeordertext="";
    if(!user.isEmailVerified){
    text="EMAIL";
    }
    if(!user.isPhoneVerified){
    text="PHONE";
    }if(!user.isEmailVerified && !user.isPhoneVerified){
      placeordertext="BEFORE PLACING AN ORDER,"
    text="EMAIL AND PHONE NO.";
    }
    
    if(user.dob=='1000-12-01'){
      text="birthday"
    }



    return <Banner>
      <span>{placeordertext}{placeordertext==""?"":<br></br>}PLEASE VERIFY YOUR <strong>{text}</strong> UNDER PROFILE SETTINGS.
      
      </span>
      <Link to="/settings?edit=profile" style={{ color: "white" }}> GO TO PROFILE SETTINGS</Link>
      

    </Banner>;
  }
}

export const EmailVerificationBanner = connect((state) => {
  return {
    user: state.getIn(['users', 'user']),
  };
})(EmailVerificationBannerWrapper);


// WEBPACK FOOTER //
// ./src/containers/commons/Banners.js